import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class sortQuery {
    limitQueryCondition(query, filterOption) {
        query.limit(filterOption.value);
    }
    skipQueryCondition(query, filterOption) {
        query.skip(filterOption.value);
    }
    ascendingQueryCondition(query, filterOption) {
        query.ascending(filterOption.value);
    }
    descendingQueryCondition(query, filterOption) {
        query.descending(filterOption.field);
    }
    existsQueryCondition(query, filterOption) {
        query.exists(filterOption.value);
    }
    doesNotExistQueryCondition(query, filterOption) {
        query.doesNotExist(filterOption.value);
    }

    containsCondition(query, filterOption) {
        query.contains(filterOption.field, filterOption.value);
    }

}


